import {
  ENUM_PERMISSIONS_LIST,
  ENUM_PERMISSIONS_LIST_SUCCESS,
  ENUM_PERMISSIONS_LIST_ERROR,
} from "./actionTypes"


export const enumPermissionsList = data => ({
  type: ENUM_PERMISSIONS_LIST,
  payload: data
});

export const enumPermissionsListSuccess = data => ({
  type: ENUM_PERMISSIONS_LIST_SUCCESS,
  payload: {data}
});

export const enumPermissionsListError = error => ({
  type: ENUM_PERMISSIONS_LIST_ERROR,
  payload: error,
});
